export default __webpack_public_path__ + "static/lgbtq-pr-sj-4-9e65c1b2dfd346b0f443b6fbfd1985ba.jpg";